export const checkTouchDevice = "ontouchstart" in window;
